export const APP_STORE_LINK =
    'https://apps.apple.com/ng/app/whoriddle/id1638671136';
export const GOOGLE_PLAY_LINK =
    'https://play.google.com/store/apps/details?id=com.whoriddle.v2';
